import { render, staticRenderFns } from "./PQRMatch.vue?vue&type=template&id=5edf4dee&scoped=true"
import script from "./PQRMatch.vue?vue&type=script&lang=js"
export * from "./PQRMatch.vue?vue&type=script&lang=js"
import style0 from "./PQRMatch.vue?vue&type=style&index=0&id=5edf4dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf4dee",
  null
  
)

export default component.exports